import type { ComponentChildren } from "preact"
import { track_demo_click } from "@/utils/analytics"

export const DEMO_LINK = "https://calendly.com/nat-marginwiz/30min"

interface DemoLinkProps {
  class?: string
  target?: "_blank"
  children?: ComponentChildren
}

/** "Book a demo" CTA. Fires the Google Ads conversion + PostHog event on click. */
export function DemoLink({ class: className, target, children }: DemoLinkProps) {
  return (
    <a
      class={className}
      href={DEMO_LINK}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      onClick={track_demo_click}>
      {children ?? "Book a demo"}
    </a>
  )
}
